import PersonAvatar from './PersonAvatar.js';

export default PersonAvatar;
